import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useSearchablePages from '../hooks/useSearchablePages';
import LoadingIndicator from '../../website/components/stateless/LoadingIndicator';
import PageListDescendantPagesBody from '../components/PageListDescendantPagesBody';

const GET_DATA = gql`
  query PageListDeletePagesData($includeIds: [ID!]) {
    pages(filter: { includeIds: $includeIds }) {
      edges {
        node {
          id
          breadcrumbTrail {
            id
            descendantPages {
              id
              url
            }
          }
        }
      }
    }
  }
`;

const propTypes = {
  ids: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  message: PropTypes.string,
  onLoad: PropTypes.func,
};

const defaultProps = {
  message: null,
  onLoad: undefined,
};

const PageListDescendantPages = ({ ids, message, onLoad }) => {
  if (!ids.length) {
    return null;
  }

  const [state] = useSearchablePages(
    GET_DATA,
    {
      variables: {
        includeIds: ids,
      },
    },
    [ids],
  );

  const { loading, pages } = state;

  if (loading) {
    return (
      <div style={{ height: '300px' }}>
        <LoadingIndicator />
      </div>
    );
  }

  if (!loading && onLoad) {
    onLoad(false);
  }

  if (!pages || !pages.length) {
    return message;
  }

  const descendantPagesUrls = pages.reduce((arr, page) => {
    const { breadcrumbTrail } = page;
    if (
      breadcrumbTrail
      && breadcrumbTrail.descendantPages
      && breadcrumbTrail.descendantPages.length
    ) {
      return (
        [...page.breadcrumbTrail.descendantPages.map(descPage => descPage.url), ...arr]
      );
    }
    return arr;
  }, []);

  if (!descendantPagesUrls || !descendantPagesUrls.length) {
    return message;
  }

  return (
    <PageListDescendantPagesBody message={message} urls={descendantPagesUrls} />
  );
};

PageListDescendantPages.propTypes = propTypes;
PageListDescendantPages.defaultProps = defaultProps;

export default PageListDescendantPages;
